export enum DocumentStatus {
  active = "active",
  archived = "archived",
}

export const enum DocumentVersionStatus {
  archived = "archived",
  draft = "draft",
  published = "published",
}

export enum UserStatus {
  active = "active",
  deactivated = "deactivated",
  pending = "pending",
  deleted = "deleted",
}

export const reviewPeriod = [
  "3 MONTH",
  "6 MONTH",
  "1 YEAR",
  "3 YEAR",
  "5 YEAR",
] as const;
export type ReviewPeriod = (typeof reviewPeriod)[number];

export enum PlatformRole {
  contributor = "contributor",
  coordinator = "coordinator",
  superAdmin = "superadmin",
  reader = "reader",
}
